import { LoginForm } from "@/components/login-form";

export const LoginPage = () => {
  return <LoginForm />;
};
